import { Button, Stack } from "@mui/material";
import { MedicationForm } from "../../medicalcare/components/MedicationForm";
import { Add, Edit } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useInterventionsContext } from "../../../contexts/InterventionsContext";
import {
  RECEITUARIO_TIPO_SELECT_AUTO,
  stampReceituarioProfile,
  type ReceituarioModelo,
  type ReceituarioTipoSelectValue,
} from "src-next/modules/sncr";
import { normalizeProtocolTiming } from "../../../utils/protocolMedicationTiming";

export function Tratamentos({
  tabValueMedication,
  handleChangeMedication,
  control,
  setValue,
  clean,
  setClean,
  handleSubmit,
  action,
  isEdit,
}: any) {
  const { medicationOptions } = useInterventionsContext();

  function getTypeByTabValue(tabValue: number) {
    switch (tabValue) {
      case 0:
        return "medication";
      case 1:
        return "supplement";
      case 2:
        return "herbalMedicine";
      default:
        return "medication";
    }
  }

  const onSubmit = async (data: any) => {
    try {
      if (!data.medication) {
        toast.warn("Selecione algum item pra efetuar a prescrição");
        throw new Error("Formulário vazio");
      } else {
        const frequency = normalizeProtocolTiming(data?.frequency, "hours");
        const time = normalizeProtocolTiming(data?.time, "days");

        const auxForm = [
          data?.quantity && `${data?.quantity}`,
          data?.form?.label && `${data?.form?.label}`,
          frequency?.label && `a cada ${frequency.label}`,
          time?.label && `por ${time.label}`,
        ]
          ?.filter((e: string) => e)
          ?.join(" ");

        const inputValue =
          medicationOptions?.find(
            (e: any) => e?.value === data?.medication?.value,
          ) || {
            name: data.medication.name,
            value: data.medication.name,
            label: data.medication.name,
          };

        const tipoSelect = (data?.receituarioTipo ||
          RECEITUARIO_TIPO_SELECT_AUTO) as ReceituarioTipoSelectValue;
        const isManual = tipoSelect !== RECEITUARIO_TIPO_SELECT_AUTO;

        const auxItem = {
          name: data?.medication?.name,
          label: data?.medication?.label,
          tag: data?.medication?.tag,
          class:
            data?.medication?.class ||
            inputValue?.class ||
            undefined,
          inputValue,
          quantity: data?.quantity,
          frequency,
          formValue: data?.form,
          time,
          note: data?.note,
          form: auxForm,
          type: getTypeByTabValue(tabValueMedication),
          code: data?.medication?.code,
          tabValue: `${tabValueMedication}`,
          ...(isManual
            ? {
                receituarioTipoManual: true,
                receituarioModelo: tipoSelect as ReceituarioModelo,
              }
            : {
                receituarioTipoManual: false,
              }),
        };

        action(stampReceituarioProfile(auxItem));
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      setClean(true);
    }
  };

  return (
    <>
      <Stack width="100%" maxHeight="60vh" overflow="auto">
        <MedicationForm
          tabValue={tabValueMedication}
          handleChange={handleChangeMedication}
          render={!clean}
          control={control}
          setValue={setValue}
        />

        <Stack
          width="100%"
          direction="row"
          mt={2}
          mb={2}
          justifyContent="right"
        >
          <Button
            sx={{ width: "fit-content", border: "1px solid #007C6D" }}
            onClick={handleSubmit(onSubmit)}
            variant="text"
          >
            {isEdit ? <Edit /> : <Add />}
          </Button>
        </Stack>
      </Stack>
    </>
  );
}
